document.addEventListener("DOMContentLoaded", function () {
  {
    // section-products
    document.querySelectorAll(".js-splide_products").forEach((element) => {
      const splide_products = new Splide(element, {
        autoplay: false,
        type: "slide",
        pagination: false,
        arrows: true,
        interval: 1000,
        speed: 300,
        fixedWidth: 255,
        perPage: 1,
        drag: true,
        start: 0,
        breakpoints: {
          1080: {
            autoWidth: true,
            gap: 0,
            arrows: false,
          },
        },
      });
      splide_products.mount();
    });
  }
});
